import { TRAFFIC_LIGHT_COLOURS as COLOURS, safetyLegend } from '@src/modules/performance/shared/constants';
import { useSafetyKPI } from '@src/modules/performance/context/map-api-hooks';
import { Text } from '@chakra-ui/react';
import Widget from './Widget';
import { CircleIndicator } from '../indicators';
import IndicatorLegend from '../IndicatorLegend';

export default function SafetyWidget() {
  const { data: safetyData, isLoading, isError } = useSafetyKPI();

  const title = 'Road Safety';
  const description = 'Trend and average number of\ndeaths & serious injuries over 10 years';

  // If there is an error we want to hide the widget
  if (isError) return null;

  return (
    <Widget
      link="/performance/dashboard/safety"
      title={title}
      description={description}
      lockYear={safetyData?.lockYear}
      quarter={null}
      isLoading={isLoading && !safetyData}
      moreInfoContent={(
        <>
          <Text fontSize="sm" mb={4}>
            The annual average number of deaths and serious injuries for the last ten financial years, including the trend for the same period:
          </Text>
          <IndicatorLegend items={safetyLegend} />
        </>
      )}
    >
      <CircleIndicator
        size={100}
        colour={COLOURS[safetyData?.colour]}
        value={safetyData?.value}
        isLoading={isLoading && !safetyData}
      />
    </Widget>
  );
}
